/**
 * Helper component for rendering radio inputs
 *
 * NOTE: To use -
 * <RadioInput
 *   label="Leaderboard Sort Order"
 *   options={[
 *     {val: 'descending', display: 'Sort Descending'},
 *     {val: 'ascending', display: 'Sort Ascending'},
 *   ]}
 *   name="sortOrder"
 *   value={item.sortOrder}
 *   change={handleFormChange}
 *   inLine={true}
 * />
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';

// import third-party libraries
import classNames from 'classnames';

const RadioInput = ({
  change
  , helpText
  , inLine
  , label
  , name
  , options
  , value
  , disabled
}) => {

  const inputClass = classNames(
    'radio-input'
    , { 'inline': inLine }
  )

  let theOptions = options.map((option, i) => {
    let isChecked = option.val === value ? true : false;
    return(
      <div key={i} className={inputClass}>
        <input
          type="radio"
          name={name}
          value={option.val}
          onChange={(e) => change(e)}
          checked={isChecked}
          disabled={disabled}
        />
        <span htmlFor={name} className="display">{option.display}</span>
      </div>
    )
  })
  return(
    <div className="input-group">
      <label htmlFor={name}>{label}</label>
      {theOptions}
      <div>
        <small className="help-text"><em>{helpText}</em></small>
      </div>
    </div>
  )
}


RadioInput.propTypes = {
  change: PropTypes.func.isRequired
  , helpText: PropTypes.any
  , inline: PropTypes.bool
  , label: PropTypes.string
  , name: PropTypes.string.isRequired
  , options: PropTypes.arrayOf(
    PropTypes.shape({
      val: PropTypes.oneOfType([
          PropTypes.string
          , PropTypes.number
        ]).isRequired
      , display: PropTypes.string.isRequired
    })).isRequired
  , value: PropTypes.any.isRequired
}

RadioInput.defaultProps = {
  helpText: null
  , inline: false
  , label: ''
}

export default RadioInput;



// WEBPACK FOOTER //
// global/components/forms/RadioInput.js.jsx